export function searchHighlight(value: string | number, querySearch: string): string | number  {
	if (!querySearch.length || value === null) {
		return value;
	}
	const querySearchReplace = (querySearch || '').trim().split(/\s+/).map(x => x.replace(/[-[\]{}()*+!<=:?.\\^$|#\s,]/g, '\\$&')).join("|");
	return value.toString().replace(
		RegExp(querySearchReplace, 'gi'),
		(matchText) => '<strong style="color: #000;">' + matchText + '</strong>'
	);
}